import axios from 'axios';

export type OutdoorPhoto = {
	url: string;
	base64: string;
	filename: string;
};

export type FetchOutdoorPhotosParams = {
	dealId: string;
	getToken: () => Promise<string>;
};

export const fetchOutdoorPhotos = async (params: FetchOutdoorPhotosParams): Promise<[Array<OutdoorPhoto> | null, string | null]> => {
	const { dealId, getToken } = params;

	try {
		const token = await getToken();
		const response = await axios.get(`${import.meta.env.VITE_API_URL}/deals/${dealId}/outdoor-photos`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		if (response.status === 200) {
			return [response.data ?? [], null];
		}

		if (response.status === 204) {
			return [[], null];
		}

		return [[], null];
	} catch (error) {
		if (axios.isAxiosError(error) && error.response?.status === 204) {
			return [[], null];
		}
		return [null, 'Error fetching outdoor photos'];
	}
};
